import { len } from './common'

export default (value, expr) => {
  return len(value) <= parseInt(expr)
}